export default __webpack_public_path__ + "static/media/FirstGen.015b3be0.JPG";